module.exports = __webpack_public_path__ + "img/019.4dca06a8.jpg";